var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarmBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 15.0021C6.66602 14.0816 7.41221 13.3354 8.33268 13.3354H14.0732V23.3354H8.33268C7.41221 23.3354 6.66602 22.5892 6.66602 21.6688V15.0021Z",
    fill: "#36AFD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 23.333H14.0722V30.1849C14.0722 31.0031 13.409 31.6663 12.5908 31.6663V31.6663C11.7726 31.6663 11.1094 31.0031 11.1094 30.1849V23.333Z",
    fill: "#9DE4FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4072 8.33301C26.589 8.33301 25.9258 8.99627 25.9258 9.81444V26.8515C25.9258 27.6697 26.589 28.333 27.4072 28.333C28.2254 28.333 28.8886 27.6697 28.8886 26.8515V23.302C30.0103 23.1766 31.0628 22.6743 31.8685 21.8685C32.8062 20.9308 33.333 19.6591 33.333 18.333C33.333 17.0069 32.8062 15.7352 31.8685 14.7975C31.0628 13.9917 30.0103 13.4894 28.8886 13.364V9.81444C28.8886 8.99627 28.2254 8.33301 27.4072 8.33301Z",
    fill: "#36AFD9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0713 13.3363L25.9228 10.0029V26.6696L14.0713 23.3362V13.3363Z",
    fill: "#9DE4FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmBlue);
export default __webpack_public_path__ + "static/media/alarm-blue.16b0869bd297fafe234b06d9a06fde9d.svg";
export { ForwardRef as ReactComponent };